const CHUNK_LOAD_PATTERNS = [
  /Loading chunk [\d]+ failed/i,
  /Loading CSS chunk [\d]+ failed/i,
  /error loading dynamically imported module/i,
  /Failed to fetch dynamically imported module/i,
  /Importing a module script failed/i,
];

export function isChunkLoadError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error ?? '');
  return CHUNK_LOAD_PATTERNS.some(p => p.test(message));
}

export function handleChunkLoadError(error: unknown): void {
  if (isChunkLoadError(error) && typeof window !== 'undefined') {
    window.location.reload();
  }
}
